<template>
  <server-list
    :key="tableRenderKey"
    ref="serverListRef"
    :request-func="fetchTree"
    search-placeholder="Пошук за кодом або назвою підрозділу...">
    <template #action-button>
      <v-btn color="primary" prepend-icon="mdi-plus" @click="openCreateDialog">
        Створити підрозділ
      </v-btn>
    </template>

    <template #items="{ items, requestData }">
      <internal-department-flat-table
        :columns="internalDepartmentListHeaders"
        :items="filterTree(items, requestData.search)"
        :open-edit-dialog="openEditDialog"
        @refresh="refreshList" />
    </template>
  </server-list>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { openDialog } from '@/dialog'
import ServerList from '@/components/ServerList.vue'
import { internalDepartmentTreeList } from '@/requests/internalDepartment'
import { internalDepartmentListHeaders } from '@/utils/tableHeaders'
import InternalDepartmentFlatTable from '@/pages/administration/org-structure/internal/InternalDepartmentFlatTable.vue'
import { Query } from 'best-modules/utils'
import { InternalDepartmentTreeItem } from '@/utils/types/internalDepartment'

type DepartmentTreeItem = Omit<InternalDepartmentTreeItem, 'users'> & {
  childItems: DepartmentTreeItem[]
}

export default defineComponent({
  name: 'InternalDepartmentList',
  components: {
    InternalDepartmentFlatTable,
    ServerList,
  },
  data() {
    return {
      internalDepartmentListHeaders,
    }
  },
  setup() {
    const tableRenderKey = ref(1)

    const fetchTree = (query: Query) => internalDepartmentTreeList(query)

    const filterTree = (nodes: DepartmentTreeItem[], search: string | null) => {
      if (!search) return nodes
      const q = search.toLowerCase()
      return nodes.reduce((acc: DepartmentTreeItem[], node) => {
        const match =
          node.name?.toLowerCase().includes(q) ||
          node.internalCode?.toLowerCase().includes(q)

        const filteredChildren = node.childItems
          ? filterTree(node.childItems, search)
          : []

        if (match || filteredChildren.length > 0) {
          acc.push({ ...node, childItems: filteredChildren })
        }
        return acc
      }, [])
    }

    const refreshList = () => {
      tableRenderKey.value += 1
    }

    const openCreateDialog = () => {
      openDialog({
        name: 'InternalDepartment',
        action: 'create',
        params: {
          title: 'Створити підрозділ',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    const openEditDialog = (item: DepartmentTreeItem) => {
      openDialog({
        name: 'InternalDepartment',
        action: 'update',
        dialogData: { itemData: item },
        params: {
          title: 'Редагувати підрозділ',
          submitLabel: 'Зберегти',
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    return {
      fetchTree,
      filterTree,
      openEditDialog,
      openCreateDialog,
      refreshList,
      tableRenderKey,
    }
  },
})
</script>
